// File: frontend/src/pages/LandingPage.js
//
// Public PesaFii marketing / product-discovery page served at "/". Composed from
// the marketing components; all auth CTAs open the existing /login page in the
// correct mode (Sign In → login, Start Free → register). No separate register or
// password-recovery routes, and no password-recovery link anywhere on this page.
//
// The page is a guided tour of the product (fictional data, no API calls):
// the dashboard on a laptop in the hero, a feature list with a sticky
// illustration, a scroll-driven product tour, the network map, and one
// purchase told step by step. Motion is GSAP (components/marketing/
// landingMotion.js) and always an enhancement over finished static markup.
//
// The page is also rendered to static HTML at build time (scripts/prerender.js),
// so everything here must render without network access.

import React from "react";
import PublicLayout from "../components/marketing/PublicLayout";
import HeroSection from "../components/marketing/HeroSection";
import ProductShowcaseTabs from "../components/marketing/ProductShowcaseTabs";
import RouterNetworkSection from "../components/marketing/RouterNetworkSection";
import PaymentFlowSection from "../components/marketing/PaymentFlowSection";
import FAQSection from "../components/marketing/FAQSection";
import FeatureShowcase from "../components/marketing/FeatureShowcase";
import StructuredData, { organizationLd, softwareApplicationLd } from "../components/marketing/StructuredData";
import {
  TrustStrip, HowItWorks, SolutionsSection, SecuritySection, PricingSection, FinalCTA,
} from "../components/marketing/LandingSections";

export default function LandingPage() {
  return (
    <PublicLayout>
      <StructuredData data={organizationLd()} />
      <StructuredData data={softwareApplicationLd()} />
      <HeroSection />
      <TrustStrip />
      <FeatureShowcase />
      <ProductShowcaseTabs />
      <RouterNetworkSection />
      <PaymentFlowSection />
      <HowItWorks />
      <SolutionsSection />
      <SecuritySection />
      <PricingSection />
      <FAQSection />
      <FinalCTA />
    </PublicLayout>
  );
}
